import { Button } from 'common/Components/Button';
import Captcha from 'common/Components/Captcha';
import Input from 'common/Components/form/Input';
import { useRouter } from 'common/hooks/useRouter';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useForgetRequest } from 'services/forgetPassword';
import { useGetCaptch } from 'services/login';

type formDate = {
  nationalCode: string;
  mobile: string;
  captchaValue: string;
};

const FormForgetRequst = () => {
  //*global
  const { navigate } = useRouter();

  //*captcha
  const { data: captcha, refetch: refetchCaptcha } = useGetCaptch();

  const handleRefetchCaptch = (): void => {
    refetchCaptcha();
    resetField('captchaValue');
  };

  //*form
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    getValues,
    setValue
  } = useForm<formDate>({
    defaultValues: {
      nationalCode: '',
      mobile: '',
      captchaValue: '',
    },
    mode: 'onChange',
  });

  const onSubmit: SubmitHandler<formDate> = (data) => {
    if (!captcha?.key) {
      handleRefetchCaptch();
      return;
    }

    const reqData: reqForgetPasswordRequestType = {
      nationalCode: data.nationalCode,
      mobile: data.mobile,
      captchaValue: data.captchaValue,
      captchaKey: captcha?.key,
    };
    mutateForgetRequest(reqData);
  };

  //*mutateForgetRequest
  const { mutate: mutateForgetRequest } = useForgetRequest({
    onSuccess: (data) => {
      if (data.succeeded) {
        const {
          result: { expireDate, retryToken, starredMessage },
        } = data;
        navigate.push('/forget-password/validation', {
          state: {
            expireDate,
            retryToken,
            starredMessage,
            mobile: getValues('mobile'),
            nationalCode: getValues('nationalCode'),
          },
        });
      } else {
        handleRefetchCaptch();
      }
    },
    onError: () => {
      handleRefetchCaptch();
    },
  });

  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input
        {...register('nationalCode', {
          required: {
            value: true,
            message: t('Errors.Input.Required', {
              n: 'نام کاربری',
            }),
          },
        })}
        placeholder={'نام کاربری خود را وارد نمایید'}
        classparent="mt-4"
        classInput="ltrInsert"
        type={'text'}
        label={'نام کاربری'}
        // iconend={<KeyboardIcon className='text-L-gray-150 dark:text-D-gray-150' />}
        textError={errors.nationalCode?.message}
      />

      <Input
        {...register('mobile', {
          required: {
            value: true, message: t('Errors.Input.Required', {
              n: t('FormSide.Input.PhoneNumber.Label'),
            }),
          },
          // validate: { passwordValidation }
        })}
        placeholder={t(`FormSide.Input.PhoneNumber.Placeholder`)}
        classparent="mt-6"
        classInput="ltrInsert"
        type={'text'}
        label={t(`FormSide.Input.PhoneNumber.Label`)}
        // iconend={<KeyboardIcon className='text-L-gray-150 dark:text-D-gray-150 mr-2' />}
        textError={errors.mobile?.message}
      />

      <div className="mt-10">
        <Captcha
          register={register}
          errors={errors}
          captcha={captcha}
          onRefresh={handleRefetchCaptch}
          setValue={setValue}
          getValues={getValues}
        />
      </div>

      <div className="mt-12 text-center">
        <Button className="w-full bg-L-secondary-50 dark:bg-D-secobg-L-secondary-50 rounded text-L-basic dark:text-D-basic p-2 text-3xl">
          {t(`FormSide.Confirm.Login`)}
        </Button>

        <Button
          onClick={(e) => {
            e.preventDefault()
            navigate.back()
          }}
          className="text-L-gray-300 w-full p-2 rounded mt-4 text-3xl md:mb-3"
        >
          {t(`FormSide.BackText`)}
        </Button>
      </div>
    </form>
  );
};

export default FormForgetRequst;
